module.exports = __webpack_public_path__ + "img/58.e1510c0f.png";